"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockLayout = void 0;
var entity_select_transform_1 = require("../../utils/entity-select-transform");
var create_entity_1 = require("../../utils/create-entity");
exports.BlockLayout = {
  name: 'BlockLayout',
  type: 'site',
  useOpenGraph: true,
  valueImageStyle: 'banner',
  select: {
    transform: function (entity, context) {
      return __assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context));
    },
    queryFields: "\n      description { id plain }\n      preview { id url thumbnails { id small { id url } } }\n    "
  },
  form: {
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'longText',
        recommended: false
      },
      preview: {
        type: 'image',
        description: "Provide a screenshot of the design of this layout, for reference."
      },
      component: {
        type: 'text',
        monospace: true,
        description: 'Which front-end component is used to render this {{BLOCK_LAYOUT}}? If not specified, this will be \'BlockLayout\' followed by the TitleCase form of the name. Note: this setting indicates to website developers which component will display the information in the {{BLOCK}} making use of it'
      }
    })
  },
  autoRoutes: ['list', 'create', 'update']
};